// extracted by mini-css-extract-plugin
export default {"List":"List_List__I-q2a","horizontal":"List_horizontal__czCHA"};